var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.locations),function(location){return _c('aut-location-card',{key:location.id,attrs:{"location":location,"event-bus":_vm.eventBus}})}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading",staticStyle:{"height":"50px","margin-top":"2rem"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }